import { render, staticRenderFns } from "./documentPreview.vue?vue&type=template&id=09874851&scoped=true&"
import script from "./documentPreview.vue?vue&type=script&lang=js&"
export * from "./documentPreview.vue?vue&type=script&lang=js&"
import style0 from "./documentPreview.vue?vue&type=style&index=0&id=09874851&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09874851",
  null
  
)

export default component.exports